// This file is automatically generated. DO NOT EDIT.

import { type ScaleResult } from '../../../../types/response/ScaleResult';
import { getJSONResponse, type GetJSONResponseOptions } from '@api/internal';

export interface GetScaleResultsResponse {
  /** The scale results */
  results: Array<ScaleResult>;
}

export async function getScaleResultsResponse(
  response: Response,
  options?: GetJSONResponseOptions<GetScaleResultsResponse>,
): Promise<GetScaleResultsResponse> {
  return getJSONResponse<GetScaleResultsResponse>(
    response,
    'getScaleResultsResponse',
    options,
  );
}
